import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const CalendarEventIcon = ({
    size = 16,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 16"
        fill={color}
        xmlns="http://www.w3.org/2000/svg">
        <path clipRule="evenodd"
            d="M5.767 1.65a.65.65 0 0 0-1.3 0v1.083H2.95A1.95 1.95 0 0 0 1 4.683v7.8a1.95 1.95 0 0 0 1.95 1.95h3.9a.65.65 0 1 0 0-1.3h-3.9a.65.65 0 0 1-.65-.65v-5.85H14v1.95a.65.65 0 1 0 1.3 0V4.683a1.95 1.95 0 0 0-1.95-1.95h-1.517V1.65a.65.65 0 1 0-1.3 0v1.083H5.767V1.65ZM14 4.683v.65H2.3v-.65a.65.65 0 0 1 .65-.65h10.4a.65.65 0 0 1 .65.65Zm1.11 6.96a.65.65 0 1 0-.92-.92l-3.006 3.008-1.274-1.274a.65.65 0 1 0-.92.92l1.734 1.733a.65.65 0 0 0 .92 0l3.466-3.467Z"/>
    </svg>
);
CalendarEventIcon.displayName = 'CalendarEventIcon';
export default CalendarEventIcon;
